<div fxLayout="row" fxLayoutAlign="space-between" class="border-bottom dialog-title">
	<h3 class="arc-h3 margin-20" id="edit-cp-title" matDialogTitle *ngIf="systemicData?.systemicDetail">
		View or Edit Systemic {{ systemicData?.systemicDetail?.systemicCase?.status?.description || 'Case' }}:&nbsp;
		{{ systemicData?.systemicDetail?.systemicCase?.caseName || '' }}
	</h3>
	<h3 class="arc-h3 margin-20" id="edit-cp-title" matDialogTitle *ngIf="!systemicData?.systemicDetail">
		Add Systemic Case
	</h3>
	<div class="text-right">
		<app-close-mat-dialog class="margin-right-10" (closeDialog)="cancel()"></app-close-mat-dialog>
	</div>
</div>

<div mat-dialog-content class="border-bottom">
	<mat-card appearance="outlined" class="grey-bg">
		<app-shared-edit-systemic-case
			#editSystemicCase
			[hasOGC]="hasOGC"
			[statutesComb] = "statutesComb"
			[readonly]="!hasEditRight"
			[isSystemCase]="systemicData?.isSystemCase"
			[systemicData]="systemicData"
			(onSave)="save($event)"
			(optionChange)="disableSaveBtn = !$event"
			[enableSystemicInvestigation]="enableSystemicInvestigation"
            [showWatchList]="showWatchList"
		>
		</app-shared-edit-systemic-case>
	</mat-card>
</div>

<mat-card appearance="outlined" fxLayout="row wrap" fxLayoutAlign="space-between" class="padding-20">
	<button type="button" mat-button color="primary" appDebounceClick (debounceClick)="reset()">Reset</button>
	<button
		type="submit"
		mat-flat-button
		id="md-sys-dlg-confirmSave-btn"
		color="primary"
		class="pull-text-right"
		*ngIf="!(systemicData?.isCreateSystemic || systemicData?.isSystemCase)"
		[disabled]="disableSave()"
		appDebounceClick
		(debounceClick)="confirmSave()"
	>
		Preview Query Criteria Results
	</button>
	<button
		type="submit"
		id="md-sys-dlg-confirmSave-btn"
		mat-flat-button
		color="primary"
		class="pull-text-right"
		*ngIf="systemicData?.isCreateSystemic || systemicData?.isSystemCase"
		[disabled]="disableSave() || this.disableSaveBtn"
		appDebounceClick
		(debounceClick)="onSave(editSystemicCase)"
	>
		Create Systemic Case
	</button>
</mat-card>
